var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgCassiopeiaBadgeTwitterOutline = function SvgCassiopeiaBadgeTwitterOutline(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38.795,
    height: 50,
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m19.29 5.489-4.638 2.71-5.29.108-2.428 4.408-4.41 2.578.029 5.373L0 25.301l2.604 4.305.027 5.11 4.668 2.66 2.738 4.529 5.031-.102 4.438 2.53 4.637-2.711 5.293-.108 2.427-4.408 4.41-2.578-.029-5.375 2.55-4.633-2.6-4.305-.03-5.11-4.668-2.66-2.738-4.529-5.031.102z",
    style: {
      fill: "#fff",
      fillOpacity: 0.501961,
      stroke: "#000",
      strokeWidth: 1,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "4,1",
      strokeDashoffset: 4.4,
      strokeOpacity: 0.501961
    }
  }));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCassiopeiaBadgeTwitterOutline);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/cassiopeia-badge-twitter-outline.82769401965b097563435e12390461e9.svg";